import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { generateRoutes, generateRouting } from '@fabiulous/routing';

import { routes } from '@shared/routes';

import { addQuery } from './helpers/query';

const { RoutingContext: _RoutingContext, useRouter: _useRouter, useQueryState: _useQueryState, useDebouncedQueryState: _useDebouncedQueryState } = generateRouting(() => {}, routes);

export const RoutingContext = _RoutingContext;

export const RoutingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {

  const navigate = useNavigate();
  const location = useLocation();

  const go = React.useCallback((pathname: string, params: CVT.Maybe<Record<string, unknown>>, replace: boolean = false) => {
    navigate({
      pathname,
      search: params && addQuery(window.location.search, params),
    }, {
      replace,
    });
  }, [navigate]);

  const router = React.useMemo(() => generateRoutes(go, routes), [go]);

  return (
    <RoutingContext.Provider value={{
      router,
      location,
      go: (params: CVT.Maybe<Record<string, unknown>>, replace?: boolean) => go(location.pathname, params, replace),
    }}>
      {children}
    </RoutingContext.Provider>
  );
};

export const RoutingConsumer = RoutingContext.Consumer;

export const useRouter = _useRouter;
export const useQueryState = _useQueryState;
export const useDebouncedQueryState = _useDebouncedQueryState;
